import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./interceptor";

// Disable console logs in production
if (process.env.REACT_APP_ENV !== "local") {
    console.log = () => { };
    console.warn = () => { };
    console.info = () => { };
}

const container = document.getElementById("root");

const tree =
    process.env.NODE_ENV === "production" ? (
        <React.StrictMode>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </React.StrictMode>
    ) : (
        <HelmetProvider>
            <App />
        </HelmetProvider>
    );

// Prerendered routes (see prerender.js) ship real markup inside #root, so we
// hydrate rather than client-render to reuse the static HTML the crawler saw.
// Non-prerendered routes have an empty #root and fall back to createRoot.
if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, tree);
} else {
    ReactDOM.createRoot(container).render(tree);
}
